// Hapus tag HTML dari input teks untuk mencegah HTML injection,
// mis. `"><a href='https://google.com/'>weird</a>` pada Nama Perusahaan / Nama Lengkap.
export const stripHtml = (value) => {
    if (typeof value !== 'string') return value
    return value.replace(/<[^>]*>?/g, '').replace(/[<>]/g, '')
}
